import { mapMutations, mapGetters } from 'vuex'
import { SET_GLOBAL_LOADING } from '../../store/mutation-types'
import _ from 'lodash'

const waitChildrenLoad = el => {
  const childrenImgs = _.map(Array.from(el.querySelectorAll('img')), img => {
    return new Promise((resolve, reject) => {
      if (img.complete) return resolve()
      img.addEventListener('load', resolve)
    })
  })

  return Promise.all(childrenImgs)
}

const poller = hash => {
  return new Promise((resolve, reject) => {
    const frame = async () => {
      const element = document.querySelector(hash)
      if (element === null) {
        window.requestAnimationFrame(frame)
      } else {
        await waitChildrenLoad(element)
        resolve(element)
      }
    }
    window.requestAnimationFrame(frame)
  })
}

const hashScroll = {
  computed: {
    ...mapGetters([
      'loading'
    ])
  },
  methods: {
    ...mapMutations({
      setLoading: SET_GLOBAL_LOADING
    }),
    async $_scrollToHash (hash) {
      this.setLoading(true)
      const element = await poller(hash)
      this.setLoading(false)
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'center'
      })
    }
  }
}

export default hashScroll
